import { useSettingsState } from "@/context/SettingsStateContext";
import { useCallback } from "react";

export default function useSettingsSubject() {
  const { subjects, newSubject, setSubjects, setNewSubject } = useSettingsState();

  // Memoize handlers for subject management
  const handleAddSubject = useCallback(() => {
    if (newSubject.trim() && !subjects.includes(newSubject.trim())) {
      setSubjects([...subjects, newSubject.trim()]);
      setNewSubject("");
    }
  }, [newSubject, subjects]);

  const handleRemoveSubject = useCallback(
    (subject: string) => {
      setSubjects(subjects.filter((s) => s !== subject));
    },
    [subjects]
  );

  return {
    handleAddSubject,
    handleRemoveSubject,
  };
}
